import React, { useMemo } from 'react';
import classnames from 'classnames';
import ReactTooltip from 'react-tooltip';
import shortid from 'shortid';
import { map, isArray, head, isEmpty, isNil, slice, castArray, size, find } from 'lodash';

// local dependencies
import { textWithPatternMatch } from 'utils/textWithPatternMatch';
import { getLabel } from 'utils/getLabel';
import { Tooltip } from 'modules/tooltip';

/**
 * @desc Data cell view for single or mult-select data cells.
 * @example
 * import { simpleSelect as SimpleSelectCellView } from './cellViews/simpleSelect.view';
 */
export const simpleSelect = ( props ) => {

    // extract display values and field values
    const displayValues = map( castArray( props.value ), ( fieldValue, index ) => {
                                
        // if `column.options` is an array of `array`, extract options from the `column.options` based on the `index`
        const options = isArray( head( props.options ) ) ? props.options[ index ] : props.options;

        // return display label (title) as value
        const option = find( options, { value: fieldValue } );
        return ! isEmpty( option ) ? getLabel( option.title ) : fieldValue;
    } );

    // find display colors
    const displayColors = map( castArray( props.value ), value => props.displayColors[ value ] );

    // get visible display values based on `maxDisplayValues`
    const isValueTruncated = ! isNil( props.maxDisplayValues ) && ( 1 < size( displayValues ) );
    const visibleDisplayValues = isValueTruncated ? slice( displayValues, 0, props.maxDisplayValues ) : displayValues;
    
    // dynamic class name
    const widgetClassName = classnames( 'ui-table-cell-view-simple-select', props.className, {
        'ui-table-cell-view-simple-select--truncated': isValueTruncated,
    } );

    // item class name
    const itemClassName = classnames( 'ui-table-cell-view-simple-text__display-values__items__item', {
        'ui-table-cell-view-simple-text__display-values__items__item--red-text': props.shouldTextBeRed,
        'ui-table-cell-view-simple-text__display-values__items__item--blue-text': props.shouldTextBeBlue,
    } );

    // unique id
    const uniqId = useMemo( shortid.generate, [] );

    return (
        <div className={ widgetClassName }>
            {/* display values */}
            <div className='ui-table-cell-view-simple-select__display-values'>
                {/* items */}
                <div className='ui-table-cell-view-simple-select__display-values__items'>
                    {
                        visibleDisplayValues.map( ( visibleDisplayValue, index ) => {
                            return (

                                // <div
                                //     key={ index }
                                //     className='ui-table-cell-view-simple-select__display-values__items__item'
                                //     style={ { color: displayColors[ index ] } }
                                //     dangerouslySetInnerHTML={ { __html: props.isSearchable ? textWithPatternMatch( {
                                //         value: visibleDisplayValue,
                                //         patterm: props.searchQuery,
                                //         wildcard: false,
                                //     } ) : visibleDisplayValue } }
                                //     { ...( isValueTruncated ? { 'data-tip': 'true', 'data-for': uniqId } : {} ) }
                                // />
                                <Tooltip
                                    key={ index }
                                    text={ visibleDisplayValue }
                                    active={ ! isValueTruncated }
                                    activateOnOverflow={ true }
                                    render={ ( binding = {} ) => (
                                        <div
                                            { ...binding }
                                            className={ itemClassName }
                                            style={ { color: displayColors[ index ] } }
                                            dangerouslySetInnerHTML={ { __html: props.isSearchable ? textWithPatternMatch( {
                                                value: visibleDisplayValue,
                                                pattern: props.searchQuery,
                                                wildcard: true,
                                                type: props.columnType,
                                            } ) : visibleDisplayValue } }
                                            { ...( isValueTruncated ? { 'data-tip': 'true', 'data-for': uniqId } : {} ) }
                                        />
                                    ) }
                                />
                            );
                        } )
                    }
                </div>

                {/* plus button */}
                {
                    isValueTruncated ? (
                        <div
                            className='ui-table-cell-view-simple-select__display-values__plus-button'
                            { ...( isValueTruncated ? { 'data-tip': 'true', 'data-for': uniqId } : {} ) }
                        >
                            +{ size( displayValues ) - 1 }
                        </div>
                    ) : null
                }
            </div>
            

            {/* tooltip */}
            {
                isValueTruncated ? (
                    <ReactTooltip
                        id={ uniqId }
                        aria-haspopup='true'
                        delayShow={ 300 }
                        className='ui-table-cell-view-simple-select__tooltip'
                        backgroundColor={ '#cdd7e1' }
                    >
                        {
                            displayValues.map( ( _valItem, _index ) => {
                                return (
                                    <p key={ _index } className='ui-table-cell-view-simple-select__tooltip__value'>
                                        { _valItem }
                                    </p>
                                );
                            } )
                        }
                    </ReactTooltip>
                ) : null
            }
        </div>
    );
};

// display name
simpleSelect.displayName = 'table.cellViews.simpleSelect';

// default values
simpleSelect.defaultValues = {
    value: [],
    maxDisplayValues: undefined,
    displayColors: {},
    isSearchable: false,
    searchQuery: '',
};
